export default "__VITE_ASSET__DiIyd2Gb__"